module.exports = __webpack_public_path__ + "img/arrow-up-1.ab92c5c3.svg";